import React, { useEffect, useMemo, useState } from "react";
import { Stack, Typography } from "@mui/material";

import { useDebounce, useGetSearchPartList } from "../../hooks";
import { HubHookFormTagInput } from "../HubHookFormTagInput";

const Label = ({ label }) => (
  <Typography
    sx={{
      fontSize: "12px !important",
      fontWeight: 500,
    }}
  >
    {label}
  </Typography>
);

export const HubHookFormPartSelect = ({
  label = "Search for Part",
  name = "partId",
  multiple = false,
  disabled,
  ...rest
}) => {
  const [search, setSearch] = useState();
  const { data, isSuccess, refetch } = useGetSearchPartList(search);
  const options = useMemo(() => data || [], [isSuccess, data]);

  useEffect(() => {
    refetch();
  }, [search]);

  const RenderComponent = ({ label }) => (
    <Stack direction="row" gap="10px" alignItems="center">
      <Label label={label} />
    </Stack>
  );

  const handleOnChange = (e, searchString) => {
    e?.preventDefault();
    e?.stopPropagation();
    setSearch(searchString);
  };

  const onChangeDebounce = useDebounce((e, searchString) => {
    handleOnChange(e, searchString);
  }, 500);

  const renderTags = (value, getTagProps) =>
    value.map(
      (option, index) =>
        option && <Label key={option?.id || index} label={option?.label} />
    );

  const sharedProps = {
    options,
    disabled,
    label,
    name,
    disableHelperText: true,
    required: true,
    onInputChange: onChangeDebounce,
    filterOptions: (options) => options,

    filterTags: false,
    multi: false,
    ...(multiple ? {} : { multiple: false, renderTags, RenderComponent }),
    ...rest,
  };

  return <HubHookFormTagInput fullWidth {...sharedProps} />;
};

export default HubHookFormPartSelect;
